export default __webpack_public_path__ + "static/media/semmershoes.3fb17dca.png";